// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_10-2";
export var blackBorderOnHover = "_10-7";
export var cell = "_10-6";
export var cellContainer = "_10-3";
export var checked = "_10-8";
export var disabled = "_10-5";
export var featuredIconCellContainer = "_10-9";
export var featuredIconTextContainer = "_10-b";
export var featuredIconWrapper = "_10-a";
export var noBorder = "_10-c";
export var orangeSelectedRow = "_3g-3";
export var overflowableText = "_10-0";
export var overflowableTextContainer = "_10-1";
export var row = "_11-0";
export var rowCheckboxCell = "_10-4";
export var selectableTable = "_3g-2";